export const retrieveItem = <T>(key: string): T | undefined => {
  try {
    const data = localStorage.getItem(key);
    if (!data) return undefined;

    const parsed = JSON.parse(data);

    if (parsed.ttl && parsed.ttl < Date.now() / 1000) {
      localStorage.removeItem(key);
      return undefined;
    }

    return parsed.data as T;
  } catch (e) {
    return undefined;
  }
};

export const storeItem = <T>(key: string, item: T, ttl?: number): void => {
  try {
    localStorage.setItem(
      key,
      JSON.stringify({
        ttl: ttl ? Date.now() / 1000 + ttl : undefined,
        data: item,
      }),
    );
  } catch (e) {
    return;
  }
};
